import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  TextField,
  Box,
  Paper,
  Snackbar,
  
} from "@mui/material";
import { investorApi } from "../api/api";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import GradientButton from "../components/common/GradiantButton";
import MuiAlert from "@mui/material/Alert";

const EditBankDetails = () => {
  const UserId=useSelector((state)=>state.user.userId);
  const location = useLocation();
  const [snackbar, setSnackbar] = useState({
      open: false,
      message: "",
      severity: "success",
    });

  const [formData, setFormData] = useState({
    AccountHolderName: "",
    AccountNumber: "",
    IFSCCode: "",
    Branch: "",
    BankName:""
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (location.state) {
      setFormData(location.state);
    }
  }, [location.state]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
    const showSnackbar = (message, severity = "success") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  try {
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    const response = await investorApi.editBankDetails(UserId, data);

    if (response.status === 200) {
      showSnackbar("Bank details updated successfully!", "success");
    } 
    
    else {
      throw new Error("Update failed");
    }
  } catch (err) {
    if (err.status === 400) {
  showSnackbar("Please update at least one detail before saving.", 'warn');
}

    else{
    showSnackbar("Failed to update", "error");
  }
  } finally {
    setLoading(false);
  }
};


  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Edit Bank Details
        </Typography>

        <Box
          component="form"
          sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 2 }}
        >
          <TextField
            label="Account Holder Name"
            name="AccountHolderName"
            value={formData.AccountHolderName}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
          label="Bank Name"
          name="BankName"
          value={formData.BankName}
          onChange={handleChange}
          fullWidth
          required/>
          <TextField
            label="Account Number"
            name="AccountNumber"
            value={formData.AccountNumber}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label="IFSC Code"
            name="IFSCCode"
            value={formData.IFSCCode}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label="Branch"
            name="Branch"
            value={formData.Branch}
            onChange={handleChange}
            fullWidth
            required
          />
          <GradientButton text={loading ? "Updating..." : "Update Bank Details"}
          width="100%"
          onClick={handleSubmit}
          style={{marginTop:3}}/>

          
        </Box>
      </Paper>
       <Snackbar
              open={snackbar.open}
              autoHideDuration={4000}
              onClose={handleCloseSnackbar}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <MuiAlert
                onClose={handleCloseSnackbar}
                severity={snackbar.severity}
                sx={{ width: "100%" }}
                elevation={6}
                variant="filled"
              >
                {snackbar.message}
              </MuiAlert>
            </Snackbar>
    </Container>
  );
};

export default EditBankDetails;
